<app-info-box [infoText]="infoText()">
  <h1>{{headerText()}}</h1>
</app-info-box>
